import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import { useGetProductsByBrandQuery, useGetProductsByCategoryQuery, useGetProductsByTypeQuery } from '../slices/productsApiSlice';
import Product from '../components/Product';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import ProductCarousel from '../components/ProductCarousel';
import Meta from '../components/Meta';

const FilterScreen = () => {
  const { brand, category, type, pageNumber } = useParams();
  const [keyword, setKeyword] = useState(''); 

  const {
    data: brandData,
    isLoading: brandLoading,
    error: brandError,
  } = useGetProductsByBrandQuery({ brand, pageNumber}, {skip: !brand});

  const {
    data: categoryData,
    isLoading: categoryLoading,
    error: categoryError,
  } = useGetProductsByCategoryQuery({ category, pageNumber }, {skip: !category});

  const {
    data: typeData,
    isLoading: typeLoading,
    error: typeError,
  } = useGetProductsByTypeQuery({ type, pageNumber }, {skip: !type});

  // Determine which data to display
  const data = brand ? brandData : category ? categoryData : typeData ? typeData : null;
  const isLoading = brand ? brandLoading : category ? categoryLoading : typeLoading ? typeLoading : false;
  const error = brand ? brandError : category ? categoryError : typeError ? typeError : null;

  return (
    <>
      {!brand && !category && !type? (
        <ProductCarousel />
      ) : (
        <Link to='/' className='btn btn-outline-onraoad mb-4'>
          Atras
        </Link>
      )}

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.data?.message || error?.error}
        </Message>
      ) : (
        data && (
          <>
            <Meta />
            <h1>Lista Productos</h1>
            <Row>
              {data.products.map((product) => (
                <Col key={product._id} sm={12} md={6} lg={4} xl={3}>
                  <Product product={product} />
                </Col>
              ))}
            </Row>
            <Paginate
              pages={data.pages}
              page={data.page}
              keyword={keyword ? keyword : ''}
            />
          </>
        )
      )}
    </>
  );
};

export default FilterScreen;
